import React from "react";
import moment from "moment";
import { BsPinAngleFill } from "react-icons/bs";


export default function AssessmentDetails(props) {
  let {
    getAssessmentReportByEmpIDData,
    managerName,
    EditDetailsFn,
    EditButtonFn,
    createdAt,
    title
  } = props;

  function getModifiedContent(text) {
    let text2 = "";
    if (text) {
      text2 = text
        .replace(/<\/?li[^>]*>/g, "@")
        .replace(/<\/?ul[^>]*>/g, "")
        .replace(/<\/?span[^>]*>/g, "")
        .replace(/<\/?p[^>]*>/g, "")
        .replace(/&nbsp;/g, "")
        .replace(/<\/?br[^>]*>/g, "")
        .replace(/<\/?b[^>]*>/g, "");
    }
    return text2 ? text2 : text;
  }

  function getBulletPoints(element, field) {
    let descX =
      element && element.details && element.details[field]
        ? element.details[field]
        : "";
    let descNew = "";
    if (descX) {
      let temp = getModifiedContent(descX);
      //console.log("descX",descX)
      //console.log("temp",temp)
      descNew = temp.split("@").filter((prev) => prev !== "");
      // //console.log("descNew",descNew)
    }
    return descNew;
  }

  function getSummaryBulletPoints(element, field) {
    let descX =
      element && element[field]
        ? element[field]
        : "";
    let descNew = "";
    if (descX) {
      let temp = getModifiedContent(descX);
      //console.log("descX",descX)
      //console.log("temp",temp)
      descNew = temp.split("@").filter((prev) => prev !== "");
      // //console.log("descNew",descNew)
    }
    return descNew;
  }


  function getTitle(element, type) {
    let itemName =
      type === 1
        ? "How to use - talent every day?"
        : "How to deal with a person who has - talent?";
    let final = itemName.replace("-", element.dimension.trim().toLowerCase());
    //console.log("final--->", final.toString());
    return final.toString();
  }

  const cirleColor = (element) => {
    return (
      <span
        style={{
          background:
            element && element.colorCode ? element.colorCode : "#DDDDDD",
        }}
        className={"w-5 h-5 rounded-full "}
      />
    );
  };

  function hexToRgbA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split("");
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = "0x" + c.join("");
      return (
        "rgba(" +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
        "," +
        opacity +
        ")"
      );
    }
    throw hex;
  }


  function chunkList15(array) {
    const chunkSize = 15;
    let list = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      const chunk = array.slice(i, i + chunkSize);
      list.push(chunk);
    }
    //console.log("list--->", list);
    return list;
  }


  function chunkList(array) {
    const chunkSize = 10;
    let list = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      const chunk = array.slice(i, i + chunkSize);
      list.push(chunk);
    }
    //console.log("list--->", list);
    return list;
  }

  function BoldText(text) {
    return text ? '<b>' + text + '</b>' : text
  }

  function checkForGeneralship(bucket, dimension) {
    let text = "";
    if (bucket && dimension) {
      if (dimension.toLowerCase() === "generalship" && bucket.toLowerCase() === "thinking talents") {
        text = "old";
      } else if (dimension.toLowerCase() === "enhancer" && bucket.toLowerCase() === "relating talents") {
        text = "old";
      } else if (dimension.toLowerCase() === "coach" && bucket.toLowerCase() === "leading talents") {
        text = "old";
      }
    }
    return text
  }

  function getTopBottomIndex(list, type) {
    let range1 = 0;
    let range2 = 0;
    if (list && list.length > 0) {
      if (type === "top") {
        range1 = 5;
        range2 = 5;
      } else if (type === "mid") {
        range1 = 6;
        range2 = list.length - 5;
      } else if (type === "bottom") {
        range1 = list.length - 4
        range2 = list.length - 4
      }
    }
    return {
      "range1": range1,
      "range2": range2
    }
  }

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }



  let AssessmentList = []
  if (getAssessmentReportByEmpIDData && getAssessmentReportByEmpIDData.length > 0) {
    getAssessmentReportByEmpIDData.forEach((element) => {
      AssessmentList.push({
        ...element,
        finalSum: (Number(element.count) * Number(element.rankSum))
      })
    })
    AssessmentList.sort((b, a) => (a.finalSum - b.finalSum))
  }

  console.log("AssessmentList--1->", AssessmentList)

  let sentenceList = []
  let sentenceBlindSpotList = []
  if (AssessmentList && AssessmentList.length > 0) {
    AssessmentList.forEach((element, index) => {
      if (index + 1 <= getTopBottomIndex(AssessmentList, "top").range1) {
        let summary = element && element["summary"] ? element["summary"] : {};

        let tempList = []
        for (var i = 0; i < 7; i++) {
          if (summary && summary["title" + (i + 1).toString()]) {
            tempList.push({
              "dimension": element && element["dimension"] ? element["dimension"] : "-",
              "title": summary && summary["title" + (i + 1).toString()] ? summary["title" + (i + 1).toString()] : "-",
              "desc": summary && summary["desc" + (i + 1).toString()] ? summary["desc" + (i + 1).toString()] : "-"
            })
          }
        }
        console.log("tempList---->", tempList);

        if (tempList && tempList.length > 0) {
          let shuffleList = shuffleArray(tempList);
          if (shuffleList && shuffleList.length > 0) {
            for (var t = 0; t < (5 - index); t++) {
              let eleX = shuffleList[t];
              sentenceList.push({
                "dimension": eleX && eleX["dimension"] ? eleX["dimension"] : "-",
                "title": eleX && eleX["title"] ? eleX["title"] : "-",
                "desc": eleX && eleX["desc"] ? eleX["desc"] : "-"
              });

            }
          }
        }
      }


      if (getTopBottomIndex(AssessmentList, "bottom").range1 <= index + 1) {
        let summary = element && element["blindspot"] ? element["blindspot"] : {};

        let tempList = []
        for (var i = 0; i < 7; i++) {
          if (summary && summary["title" + (i + 1).toString()]) {
            tempList.push({
              "dimension": element && element["dimension"] ? element["dimension"] : "-",
              "title": summary && summary["title" + (i + 1).toString()] ? summary["title" + (i + 1).toString()] : "-",
              "desc": summary && summary["desc" + (i + 1).toString()] ? summary["desc" + (i + 1).toString()] : "-"
            })
          }
        }
        console.log("tempList---->", tempList);

        if (tempList && tempList.length > 0) {
          let shuffleList = shuffleArray(tempList);
          if (shuffleList && shuffleList.length > 0) {
            for (var t = 0; t < 2; t++) {
              let eleX = shuffleList[t];
              sentenceBlindSpotList.push({
                "dimension": eleX && eleX["dimension"] ? eleX["dimension"] : "-",
                "title": eleX && eleX["title"] ? eleX["title"] : "-",
                "desc": eleX && eleX["desc"] ? eleX["desc"] : "-"
              });

            }
          }
        }
      }


    })
  }

  // console.log("sentenceList---->", sentenceList);

  let label = managerName;

  // const cards = [
  //   { number: 1 }, { number: 2 }, { number: 3 }, { number: 4 }
  // ];

  // const title1 = "The Relentless Achiever: Committed To Goals With Unwavering Determination";
  // const description = `You are someone, who if decides to do something will do it, come what may. You are very serious about your goals and especially the ones about which you have spokes with your near and dear ones. You will go to any extent to ensure that those goals are fulfilled and you do not come across as someone who just speaks and does not deliver.`;


  function reverseList(list) {
    let finalList = [];
    if (list && list.length > 0) {
      for (let i = list.length - 1; i >= 0; i--) {
        finalList.push(list[i]);
      }
    }
    return finalList;
  }



  let masterList = [
    {
      "label": title + ' Bright Spot:',
      "list": sentenceList.filter((prev, index) => (index >= 0 && index < 8)),
      "isContinue": false
    },
    {
      "label": title + ' Bright Spot (Continued):',
      "list": sentenceList.filter((prev, index) => (index >= 8 && index < 15)),
      "isContinue": true
    },
    {
      "label": title + ' Blind Spot:',
      "list": sentenceBlindSpotList.filter((prev, index) => (index >= 0 && index < 8)),
      "isContinue": false
    },
    {
      "label": title + ' Blind Spot (Continued):',
      "list": sentenceBlindSpotList.filter((prev, index) => (index >= 8 && index < 15)),
      "isContinue": true
    }
  ]


  return (
    <>

      {masterList && masterList.length > 0 ?
        masterList.map((item) =>
          <main className="p-10 px-6 space-y-6 bg-white page-break">
            <div className="space-y-6 page-break">
              <div className="flex items-center justify-between w-full pt-4 pb-2 border-b text-[#212121]/85 italic">
                <h1 className="text-lg font-semibold">
                  {EditButtonFn(
                    "TalentAssessmentReport",
                    "Team TalentPlusStrengths Assessment Report"
                  )}
                </h1>
                <p className="text-lg font-semibold">{label}</p>
              </div>

              <div class="">
                <h2 class="text-2xl font-bold text-gray-800 mb-6">{item.label}</h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {item && item.list && item.list.length > 0 &&
                    item.list.map((ele, index) => (
                      <div key={index} className="bg-white relative">
                        {/* Pin icon */}
                        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-white p-1 rounded-full shadow">
                          <BsPinAngleFill className="text-black" />
                        </div>

                        {/* Title */}
                        <div className="bg-[#DAE1E9] p-3 flex space-x-2">
                          <div className="text-base text-[#000] mb-1">{
                            (item.isContinue ? (8 + index + 1).toString() : (index + 1).toString()) + "."
                          }</div>
                          <h2 className="font-medium text-base">{ele.title}</h2>
                        </div>

                        {/* Description */}
                        {getSummaryBulletPoints(ele, "desc") &&
                          getSummaryBulletPoints(ele, "desc").length > 0
                          ? getSummaryBulletPoints(ele, "desc").map(
                            (text, index) =>
                              <p className="text-gray-700 text-sm p-5 bg-[#F1F5F9]">{text}</p>
                          )
                          : null}

                      </div>
                    ))}
                </div>


              </div>

            </div>
          </main>
        ) : null}



    </>
  );
}